var map = {
	"./article-icon-0": 1,
	"./article-icon-0.png": 1,
	"./article-icon-1": 2,
	"./article-icon-1.png": 2,
	"./article-icon-2": 3,
	"./article-icon-2.png": 3,
	"./article-icon-3": 4,
	"./article-icon-3.png": 4,
	"./logo": 5,
	"./logo.png": 5
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13;